import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    async prepararContaRecorrenteDoTitulo(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('transacoesRecorrentes/access/prepararDoTitulo', dados, {timeout:60000});
        if (data?.ERRO || !data?.ID_EMITENTE) throw new Error(data?.MENSAGEM || 'Não foi possível preparar a conta recorrente.');
        return data;
    },
    getTransacoesRecorrentes(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("transacoesRecorrentes/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },    
    getTransacoesRecorrentesBox(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("transacoesRecorrentes/access/listaBox", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getTransacaoRecorrente(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("transacoesRecorrentes/access/obter", {ID_TRANSACAO_PROGRAMADA: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getTransacaoRecorrenteSimples(context, id) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("transacoesRecorrentes/access/obterSimples", {ID_TRANSACAO_PROGRAMADA: id}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deleteTransacaoRecorrente(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("transacoesRecorrentes/access/excluir", {ID_TRANSACAO_PROGRAMADA: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async postTransacaoRecorrente(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('transacoesRecorrentes/access/salvar', dados, {timeout:60000});
        return data;
    },
    getProdutosTransacao(context, dados){
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                    ApiService.setHeader();
                    ApiService.post("transacoesRecorrentes/access/listaTransacoesProdutos", dados).then(({ data }) => {
                            resolve(data);
                    });
                }
        });
    }, 
    getTransacaoRateio(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("transacoesRecorrentes/access/listaTransacaoRateio", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    gerarTransacoes(context, dados){
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                    ApiService.setHeader();
                    ApiService.post("transacoesRecorrentes/access/gerar", dados).then(({ data }) => {
                            resolve(data);
                    });
                }
        });
    }

};

export default {
    state,
    actions,
    mutations,
    getters
};
